export const GIVEAWAY_STATUS = {
    SCHEDULED: 'scheduled',
    ACTIVE: 'active',
    FINISHED: 'finished',
}

export const REWARD_STATUS = {
    WAITING_CONTACT: 'waiting_contact',
    CONTACTED: 'contacted',
    REWARDED: 'rewarded',
}

const pad = (value) => String(value).padStart(2, '0')

export const GiveawayAdapterMixin = {
    data() {
        return {
            giveawayStatusOptions: [
                {value: null, text: 'Все статусы'},
                {value: GIVEAWAY_STATUS.SCHEDULED, text: 'Ожидает старта'},
                {value: GIVEAWAY_STATUS.ACTIVE, text: 'Активен'},
                {value: GIVEAWAY_STATUS.FINISHED, text: 'Завершён'},
            ],
            rewardStatusOptions: [
                {value: REWARD_STATUS.WAITING_CONTACT, text: 'Ожидает связи'},
                {value: REWARD_STATUS.CONTACTED, text: 'Связались'},
                {value: REWARD_STATUS.REWARDED, text: 'Награда выдана'},
            ],
        }
    },
    methods: {
        /**
         * ISO 8601 с бэка -> YYYY-MM-DD HH:mm в часовом поясе браузера
         */
        formatGiveawayDate(value) {
            if (!value) return '—'
            const date = new Date(value)
            if (Number.isNaN(date.getTime())) return value

            return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
                + ` ${pad(date.getHours())}:${pad(date.getMinutes())}`
        },
        /**
         * Date -> ISO 8601 со смещением часового пояса браузера (2026-09-09T15:05:00+05:00)
         */
        toIsoWithOffset(value) {
            if (!value) return null
            const date = value instanceof Date ? value : new Date(value)
            if (Number.isNaN(date.getTime())) return null

            const offsetMinutes = -date.getTimezoneOffset()
            const sign = offsetMinutes >= 0 ? '+' : '-'
            const absOffset = Math.abs(offsetMinutes)

            return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
                + `T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
                + `${sign}${pad(Math.floor(absOffset / 60))}:${pad(absOffset % 60)}`
        },
        getGiveawayStatusText(giveaway) {
            switch (giveaway?.status) {
                case GIVEAWAY_STATUS.SCHEDULED: return 'Ожидает старта'
                case GIVEAWAY_STATUS.ACTIVE: return 'Активен'
                case GIVEAWAY_STATUS.FINISHED: return 'Завершён'
                default: return 'Неизвестно'
            }
        },
        getGiveawayStatusVariant(giveaway) {
            switch (giveaway?.status) {
                case GIVEAWAY_STATUS.SCHEDULED: return 'warning'
                case GIVEAWAY_STATUS.ACTIVE: return 'success'
                case GIVEAWAY_STATUS.FINISHED: return 'primary'
                default: return 'secondary'
            }
        },
        getCouponsTotal(giveaway) {
            return Number(giveaway?.coupons_count ?? 0)
        },
        getCouponsActivated(giveaway) {
            return Number(giveaway?.activated_coupons_count ?? 0)
        },
        getCouponsProgress(giveaway) {
            const total = this.getCouponsTotal(giveaway)
            if (!total) return 0
            return Math.min(100, Math.round((this.getCouponsActivated(giveaway) / total) * 100))
        },
        getRewardStatusText(rewardStatus) {
            const option = this.rewardStatusOptions.find(item => item.value === rewardStatus)
            return option ? option.text : 'Неизвестно'
        },
        getRewardStatusVariant(rewardStatus) {
            switch (rewardStatus) {
                case REWARD_STATUS.WAITING_CONTACT: return 'warning'
                case REWARD_STATUS.CONTACTED: return 'info'
                case REWARD_STATUS.REWARDED: return 'success'
                default: return 'secondary'
            }
        },
        getContactProviderText(provider) {
            switch (provider) {
                case 'telegram': return 'Telegram'
                case 'discord': return 'Discord'
                default: return '—'
            }
        },
    },
}
